import ajax from '../utils/request'

const homeApi = {
  /********************************首页*********************************** */
  // 登陆
  getStatData(params) {
    return ajax({
      url: '/home/statData',
      type: 'get',
      params: params
    })
  },
  // 上传图片接口
  uploadImg(param) {
    return ajax({
      url: '/vid/uploadStatic',
      type: 'post',
      params: param
    })
  },
  // 视频上传成功回调通知接口
  uploadSuccess(param) {
    return ajax({
      url: '/vid/uploadSuccess',
      type: 'post',
      params: param
    })
  },
  // 访问量折线图数据接口
  getViewsData(params) {
    return ajax({
      url: '/home/points/visit',
      type: 'get',
      params:params
    })
  },
  // 注册量折线图数据接口
  getRegisteredChart(params) {
    return ajax({
      url: '/home/points/regist',
      type: 'get',
      params:params
    })
  },

}
export default homeApi
